var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var DownloadFlatLineIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 50,
    glyphHeight: 50
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.5978 40.2479C23.2161 40.9206 24.0834 41.301 24.9945 41.3025C24.9927 41.3025 24.9909 41.3025 24.9891 41.3025H24.9999C24.9981 41.3025 24.9963 41.3025 24.9945 41.3025C25.9056 41.301 26.7838 40.9206 27.3912 40.2479L39.3369 27.2016C40.2065 26.2557 40.4347 24.875 39.913 23.6899C39.3912 22.5049 38.2173 21.7439 36.9239 21.7439H33.6847V3.27245C33.6847 1.46771 32.2173 0 30.413 0H19.576C17.7717 0 16.3043 1.46771 16.3043 3.27245V21.7439H13.0652C11.7717 21.7439 10.5978 22.5049 10.076 23.6899C9.55429 24.8641 9.78255 26.2448 10.6521 27.2016L22.5978 40.2479ZM24.9999 36.421L15.5326 26.0818H17.3912C19.1847 26.0818 20.6521 24.6141 20.6521 22.8202V4.3379H29.3478V22.8202C29.3478 24.6141 30.8152 26.0818 32.6086 26.0818H34.4673L24.9999 36.421ZM6.52174 50.0001H43.4783C47.0761 50.0001 50 47.0755 50 43.4769V39.1281C50 37.9322 49.0217 36.9537 47.8261 36.9537C46.6304 36.9537 45.6522 37.9322 45.6522 39.1281V43.4769C45.6522 44.6728 44.6739 45.6513 43.4783 45.6513H6.52174C5.32609 45.6513 4.34783 44.6728 4.34783 43.4769V39.1281C4.34783 37.9322 3.36957 36.9537 2.17391 36.9537C0.978261 36.9537 0 37.9322 0 39.1281V43.4769C0 47.0755 2.92391 50.0001 6.52174 50.0001Z",
    fill: "black"
  }));
};
export var DownloadFlatLineIconGlyph = function (props) {
  return React.createElement(DownloadFlatLineIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};